exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-excepcional[data-v-0ddb9fa7]{background-color:#008c14;color:#fff}.is-destacada[data-v-0ddb9fa7]{background-color:#00f587;color:#fff}.is-fortaleza[data-v-0ddb9fa7]{background-color:#90ffcd;color:#4a4a4a}.is-desarrollo[data-v-0ddb9fa7]{background-color:#fffd95;color:#4a4a4a}.is-mejora[data-v-0ddb9fa7]{background-color:#ffd13b;color:#4a4a4a}.is-debilidad[data-v-0ddb9fa7]{background-color:#ff4646;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ddb9fa7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lideres/Lideres.vue
// module id = 777
// module chunks = 2